define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils"], function (require, exports, $, ko, log, tools, KendoUtils) {
    "use strict";
    var PhoneNumbersImport = /** @class */ (function () {
        function PhoneNumbersImport() {
            this.providerId = ko.observable(-1);
            this.resulModel = ko.observable();
            this.hasResults = ko.observable(false);
            this.importFinished = ko.observable(false);
            this.lastError = "";
            this.isImportValid = false;
            this.tableRefreshInProgress = 0;
            this.filteredStatuses = ko.observableArray([]);
            this.importData = [];
        }
        PhoneNumbersImport.prototype.init = function () {
        };
        PhoneNumbersImport.prototype.openImport = function (callback) {
            var self = this;
            self.resulModel = ko.observable();
            self.hasResults(false);
            self.importFinished(false);
            tools.editModal({
                title: "Phone Numbers Import From Providers",
                buttonTitle: "Import",
                modalClass: "full-width no-padding",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    console.log('import phone numbers clicked');
                    //validate form
                    if (self.importData.length <= 0) {
                        tools.error("Data is empty");
                        return;
                    }
                    if (!self.providerId()) {
                        tools.error("Select Phone Numbers Provider");
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.processNumbersImport(event.currentTarget, modal, callback);
                },
                opened: function (modal) {
                    self.importData = [];
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/PhoneNumbersAudit/ImportLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phonenumbers-import-template', self }\"></div>");
                        ko.applyBindings(self, modal);
                        self.initImportGrid(self.lookupLists.GridStructures.PhoneNumbersImportGridStructure);
                    });
                },
                onResize: function (height) {
                    setTimeout(function () {
                        if (self.importTable) {
                            self.importTable.fitHeightToParent(height - 127 - 50);
                        }
                    });
                }
            });
        };
        PhoneNumbersImport.prototype.initImportGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            // self.addEditActionColumn(columns);
            self.importTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    //data: self.importData,
                    transport: {
                        read: function (options) {
                            options.success(self.importData);
                        },
                        create: function (options) {
                            self.importData.push(options.data);
                            options.success(options.data);
                        },
                        update: function (options) {
                            var dataItem = ko.utils.arrayFirst(self.importData, function (item) {
                                return item.Id === options.data.Id;
                            });
                            if (dataItem) {
                                $.extend(dataItem, options.data);
                            }
                            options.success(options.data);
                        },
                        destroy: function (options) {
                            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Id === options.data.Id; });
                            ko.utils.arrayRemoveItem(self.importData, dataRow);
                            options.success(options.data);
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    },
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#phonenumbers-import-toolbar").html()),
                    height: 500,
                    columns: columns,
                    dataBound: function (e) {
                        var dataItems = e.sender.dataSource.view();
                        for (var j = 0; j < dataItems.length; j++) {
                            var error = dataItems[j].get("Error");
                            if (error) {
                                var row = e.sender.tbody.find("[data-uid='" + dataItems[j].uid + "']");
                                row.addClass("alert-danger");
                            }
                        }
                    },
                },
                gridId: "phoneNumbersPreviewTable"
            };
            self.importTable.initGrid(gridOptions);
            setTimeout(function () {
                self.importTable.refresh();
            });
            $("#phoneNumbersPreviewTable .btn-clear-rows").on("click", function (event) {
                var r = confirm("Are you sure you want to remove all rows");
                if (r) {
                    self.importData = [];
                    self.importTable.refresh();
                }
            });
            $("#phoneNumbersPreviewTable .k-grid-content").on("paste", function (event) {
                var pastedText = undefined;
                if (window["clipboardData"] && window["clipboardData"].getData) { // IE
                    pastedText = window["clipboardData"].getData("Text");
                }
                else if (event.originalEvent["clipboardData"] && event.originalEvent["clipboardData"].getData) {
                    pastedText = event.originalEvent["clipboardData"].getData("text/plain");
                }
                setTimeout(function () {
                    // the pasted content
                    var value = $.trim(pastedText);
                    // get the pasted rows - split the text by new line
                    var rows = value.split("\n");
                    var maxId = 0;
                    ko.utils.arrayForEach(self.importData, function (item) {
                        maxId = item.Id > maxId ? item.Id : maxId;
                    });
                    maxId++;
                    for (var i = 0; i < rows.length; i++) {
                        // get the cells - split by tab
                        var cells = rows[i].split("\t");
                        self.addNewRecord({
                            Id: maxId++,
                            Number: cells[0].trim()
                        });
                    }
                    self.importTable.refresh();
                });
                return false;
            });
        };
        PhoneNumbersImport.prototype.addNewRecord = function (record) {
            var self = this;
            // add a new item in the grid
            self.importData.push(record);
        };
        PhoneNumbersImport.prototype.processNumbersImport = function (btn, modal, callback) {
            var self = this;
            self.hasResults(false);
            var data = {
                providerId: self.providerId(),
                numbers: self.importData.map(function (x) { return x.Number; })
            };
            tools.ajaxPost({
                url: "/PhoneNumbersAudit/ImportPhoneNumbers",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    self.resulModel(ko.mapping.fromJS(result.Data, {}));
                    if (callback) {
                        callback();
                    }
                    $(modal).modal('hide');
                    alert("Import finished successfully \n\nImported: ".concat(result.Data.ImportedRecords));
                }
                else {
                    tools.error(result.Error);
                }
                self.hasResults(result.Success);
                log.log(result);
            }).always(function () {
                $(btn).button("reset");
                self.importFinished(true);
            });
        };
        return PhoneNumbersImport;
    }());
    return PhoneNumbersImport;
});
//# sourceMappingURL=phoneNumbersImport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumbersAudit/phoneNumbersImport.js
// module id = 214
// module chunks = 2